import React from "react";
import ButtonLink from "components/button-link";
import Image from "components/image";
import clsx from "clsx/lite";
import RichText from "components/rich-text";

const Minimalistic = ({ data }) => (
	<div
		className="h-88 sm:pl-5  sm:h-auto flex items-center sm:items-start bg-center bg-cover"
		style={{
			backgroundImage: `linear-gradient(
        to right, 
        rgba(0, 0, 0, 1) 0%,      
        rgba(0, 0, 0, 0) 50%,     
        rgba(255, 255, 255, 0) 50%, 
        rgba(0, 0, 0, 1) 100% 
      ), url(${data.bannerImage})`,
		}}

	>
		<div className="p-5 sm:p-10 sm:pr-0 xxl:max-w-full 
		xxl:pr-10 max-w-6xl text-center sm:text-left text-white w-full flex flex-col sm:block h-full">
			<h2 className="sm:text-[40px] text-h1-xs sm:text-left">{data.title}</h2>
			<div className="flex flex-col sm:flex-row sm:justify-between  sm:items-center w-full">
				{data.subtitle && <h3 className="text-beige text-h1-xs font-prata pt-2 sm:text-[40px] ">{data.subtitle}</h3>}
				{data.secondCta &&
					<div className="hidden sm:flex sm:ml-auto">
						<ButtonLink data={data.secondCta} className="px-8 text-base w-[237px] py-3 mr-5 text-center" />
					</div>}
			</div>
			<div className="flex justify-center sm:justify-start mt-4">
				<div className="btn-gradient-border w-[xl4] text-sm bg-black sm:bg-celadon 
					 sm:text-base text-center">{data.discountCode}</div>
			</div>
			<button className="secondary bg-red-500"></button>

			{data.secondCta && (
				<div className="mt-auto sm:hidden flex justify-center">
					<ButtonLink data={data.secondCta} className="px-8 py-3 w-[237px] text-btn text-center" />
				</div>
			)}
		</div>
	</div>
);
const Classic = ({ data }) => {
	const { image, mobileImage, title, subtitle, subHeading } = data || {};

	return (
		<div className="pt-0 md:pt-0 px-4 md:px-0">
			<div className="relative flex flex-col-reverse md:flex-col gap-6 justify-center items-center">
				{mobileImage && <Image className="md:!hidden w-full" image={mobileImage} />}
				<Image className={clsx("w-full md:min-h-128", mobileImage && "!hidden md:!block")} image={image} />
				<div className="md:absolute flex flex-col w-full md:w-[100vh] md:items-center md:text-center px-0 m-auto">
					{subHeading && <p className="font-base pt-2 mb-3">{subHeading}</p>}
					<h1 className="font-semibold leading-tight">{title}</h1>
					<p className="text-lg font-medium py-4 w-full md:w-[90vh]">
						{subtitle}
					</p>
					<ButtonLink data={data.cta} className="w-full sm:w-fit" />
				</div>
			</div>
		</div>
	);
};

const Simple = ({ data }) => {
	const { image, mobileImage, title, description } = data || {};

	return (
		<div className="pt-0 sm:max-h-fit px-4 md:px-0">
			<div className="relative flex flex-col gap-6 justify-center items-center">
				<div className="relative w-full md:absolute md:inset-0 sm:w-4/5 md:py-10 flex items-start justify-start z-30">
					<div className="w-full">
						<h2 className="font-bold py-0 max-w-xl text-center md:text-left md:pl-10 md:text-beige leading-tight">
							{title}
						</h2>
						<div className="relative w-full pt-3 md:hidden">
							{mobileImage && <Image className="w-full" image={mobileImage} />}
						</div>
						<div className="hidden md:block h-[5px] w-2/3 my-2 bg-gradient-to-r from-[#D6AD60] to-[rgba(112,91,50,0)]" />
						<div className=" max-w-xl text-left pt-3 md:text-left md:pl-10 md:text-white">
							<RichText data={{ content: description }} />
						</div>
					</div>
				</div>

				<div className="relative w-full hidden md:block">
					{image && (
						<div className="relative w-full">
							<div className="absolute inset-0 bg-gradient-to-r from-black/90 to-transparent z-20" />
							<Image className="w-full xl:max-h-88" image={image} />
						</div>
					)}
				</div>

			</div>
		</div>
	);
};


const Default = ({ data }) => (
	<div
		className="py-16 px-8 flex justify-center bg-center bg-cover"
		style={{
			backgroundImage: `linear-gradient(
        rgba(0, 0, 0, 0.5), 
        rgba(0, 0, 0, 0.5)
      ), url(${data.bannerImage})`,
		}}
	>
		<div className="p-5 sm:p-10 max-w-5xl flex flex-col items-center backdrop-blur-md gap-5 bg-center border border-beige">
			<h2 className="text-white text-center">{data.title}</h2>
			{data.subtitle && <h5 className="text-center text-white">{data.subtitle}</h5>}
			<div className="flex flex-col items-center sm:flex-row w-full justify-center gap-4">
				<ButtonLink data={data?.cta} className="w-full bg-black sm:bg-celadon  sm:w-fit text-center" />
				<ButtonLink data={data?.secondCta} className="w-full sm:w-fit text-center" />
			</div>
		</div>
	</div>
);

const BannerImage = ({ data }) => {
	switch (data.layout) {
		case "classic":
			return <Classic data={data} />;
		case "minimalistic":
			return <Minimalistic data={data} />;
		case "simple":
			return <Simple data={data} />;
		default:
			return <Default data={data} />;
	}
};

export default BannerImage;